/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'company-hub.hub-element-placeholder.config-panel.title': '要素',
  'company-hub.hub-element-placeholder.extension.lozenge-updated': '更新',
  'company-hub.hub-element-placeholder.extension.new-lozenge': 'New',
  'company-hub.hub-element-placeholder.extension.sub-heading':
    'ここにはまだ何もありません。次のようなアイデアがあります。',
  'company-hub.hub-element-placeholder.extension.view-all-options': 'すべてのオプションを表示',
  'company-hub.hub-element-placeholder.manifest.extension-title': 'ハブ要素のプレースホルダー',
};
